'use client';
import React from 'react';
import styles from './FusionNavigationLinks.module.scss';

export interface FusionNavigationLink {
  title: string;
  url: string;
}

interface Props {
  direction?: 'horizontal' | 'vertical';
  links: FusionNavigationLink[];
  linkColor?: string;
}

export const FusionNavigationLinks = ({ direction = 'horizontal', linkColor, links }: Props) => {
  return (
    <div
      className={`${styles.linksContainer} fusion-navigation-links-container-${direction}`}
      style={linkColor ? ({ '--link-color': linkColor } as React.CSSProperties) : undefined}
    >
      {Array.isArray(links) &&
        links.map((link, i) => (
          <a
            className="fusion-header-link"
            data-action={`Fusion Navigation Link Click - ${link.title}`}
            href={link.url}
            key={i}
          >
            {link.title}
          </a>
        ))}
    </div>
  );
};
